import React from "react";
import { useParams } from "react-router-dom";
import { useRoutes } from "utils/routes";

import PageSecondaryNavigation, {
  PageNavLink,
} from "components/PageSecondaryNavigation";
import OrganizationWorkbookList from "components/OrganizationWorkbookList";
import ServerGroupWorkbookList from "components/ServerGroupWorkbookList";
import ServerWorkbookList from "components/ServerWorkbookList";
import WorkbookList from "components/WorkbookList";
import PageContent from "components/PageContent";
import { useFeature } from "components/OrganizationFeatures";
import UpgradeRequired from "components/UpgradeRequired";

const QueryTuning = () => {
  const { databaseId, serverId, serverGroupId, slug } = useParams();
  const {
    databaseWorkbooks,
    serverWorkbooks,
    serverGroupWorkbooks,
    organizationWorkbooks,
  } = useRoutes();
  const hasWorkbooks = useFeature("workbooks");

  const navLink = databaseId
    ? databaseWorkbooks(databaseId)
    : serverId
    ? serverWorkbooks(serverId)
    : serverGroupId
    ? serverGroupWorkbooks(serverGroupId)
    : slug
    ? organizationWorkbooks(slug)
    : null;

  const featureNav = navLink ? (
    <PageSecondaryNavigation>
      <PageNavLink to={navLink}>Query Tuning</PageNavLink>
    </PageSecondaryNavigation>
  ) : null;

  const body = databaseId ? (
    <WorkbookList />
  ) : serverId ? (
    <ServerWorkbookList />
  ) : serverGroupId ? (
    <ServerGroupWorkbookList />
  ) : (
    <OrganizationWorkbookList />
  );

  return hasWorkbooks ? (
    <PageContent
      title="Workbooks"
      pageCategory="workbooks"
      pageName="index"
      featureNav={featureNav}
    >
      {body}
    </PageContent>
  ) : (
    <UpgradeRequired feature="Workbooks" />
  );
};

export default QueryTuning;
